import { cloneElement } from "react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Label } from "@ui/label";

export const FIELD_TRIGGER_CLASS = "h-9 bg-white text-sm";
// Never wider than the trigger, so a long label wraps instead of running off.
export const FIELD_CONTENT_CLASS =
  "max-w-[var(--radix-select-trigger-width)] [&_[role=option]]:whitespace-normal";

export const SadieSimulatorField = ({
  children,
  icon,
  id,
  label,
}: {
  children: React.ReactNode;
  icon: React.ReactElement<{ className?: string }>;
  id: string;
  label: string;
}) => (
  <Column className="gap-1.5">
    <Row className="items-center gap-2">
      {cloneElement(icon, { className: "h-4 w-4 shrink-0 text-slate-400" })}
      <Label className="text-sm font-medium text-slate-700" htmlFor={id}>
        {label}
      </Label>
    </Row>
    {children}
  </Column>
);
